export const SliderSeparators = () => (
  <>
    {/* Top */}
    <div className="col-span-1 col-start-1 row-span-1 row-start-1 ml-[-1px] rounded-br-[4px] border-b  border-r border-[#345142]" />
    <div className="col-span-1 col-start-2 row-span-1 row-start-1 ml-[-1px] rounded-b-[4px] border-x-[1px] border-b-[1px] border-[#345142]" />
    <div className="col-span-1 col-start-3 row-span-1 row-start-1 ml-[-1px] rounded-bl-[4px] border-b border-l border-[#345142]" />
    {/* Center */}
    <div className="col-span-1 col-start-1 row-span-1 row-start-2 mt-[-1px] rounded-r-[4px] border-y-[1px] border-r-[1px] border-[#345142]" />
    <div className="col-span-1 col-start-3 row-span-1 row-start-2 ml-[-1px] mt-[-1px] rounded-l-[4px] border-y-[1px] border-l-[1px] border-[#345142]" />
  </>
)

export const NavigationSeparators = () => (
  <>
    {/* Navigation Section */}
    <div className="col-span-1 col-start-1 row-span-1 row-start-1 mt-[-1px] rounded-r-[4px] border-y border-r border-[#345142]" />
    <div className="col-span-1 col-start-2 row-span-1 row-start-1 ml-[-1px] mt-[-1px] rounded-[4px] border border-[#345142] max-md:hidden" />
    <div className="col-span-1 col-start-4 row-span-1 row-start-1 ml-[-1px] mt-[-1px] rounded-[4px] border border-[#345142] max-md:hidden" />
    <div className="col-span-1 col-start-3 row-span-1 row-start-1 ml-[-1px] mt-[-1px] rounded-l-[4px] border-y border-l border-[#345142] md:col-start-5" />
    {/* Bottom */}
    <div className="col-span-1 col-start-1 row-span-1 row-start-2 mt-[-1px] rounded-tr-[4px] border-r-[1px] border-t-[1px] border-[#345142]" />
    <div className="col-span-1 col-start-2 row-span-1 row-start-2 ml-[-1px] mt-[-1px] rounded-t-[4px] border-x-[1px] border-t-[1px] border-[#345142] max-md:hidden" />
    <div className="col-span-1 col-start-2 row-span-1 row-start-2 ml-[-1px] mt-[-1px] rounded-t-[4px] border-x-[1px] border-t-[1px] border-[#345142] md:col-start-3" />
    <div className="col-span-1 col-start-4 row-span-1 row-start-2 ml-[-1px] mt-[-1px] rounded-t-[4px] border-x-[1px] border-t-[1px] border-[#345142] max-md:hidden" />
    <div className="col-span-1 col-start-3 row-span-1 row-start-2 ml-[-1px] mt-[-1px] rounded-tl-[4px] border-l-[1px] border-t-[1px] border-[#345142] md:col-start-5" />
  </>
)

export const LeftSideSeparators = () => (
  <div className="col-span-1 col-start-1 grid grid-cols-[auto,12px] max-md:hidden md:grid-rows-[38px_auto] lg:grid-rows-[64px_minmax(461px,auto)]">
    <div className="col-span-1 row-start-1 rounded-br-[4px] border-b border-r border-[#345142]" />
    <div className="col-span-1 row-start-1 ml-[-1px] rounded-bl-[4px] border-b border-l border-[#345142]" />
    <div className="col-span-1 row-start-2 mt-[-1px] rounded-r-[4px] border-y border-r border-[#345142]" />
    <div className="col-span-1 row-start-2 ml-[-1px] mt-[-1px] rounded-[4px] border-l border-[#345142]" />
  </div>
)

export const RightSideSeparators = () => (
  <div className="col-span-1 col-start-3 grid grid-cols-[12px,auto] max-md:hidden md:grid-rows-[38px_auto] lg:grid-rows-[64px_minmax(461px,auto)]">
    <div className="col-span-1 row-start-1 rounded-br-[4px] border-b border-r border-[#345142]" />
    <div className="col-span-1 row-start-1 ml-[-1px] rounded-bl-[4px] border-b border-l border-[#345142]" />
    <div className="col-span-1 row-start-2 mt-[-1px] rounded-r-[4px] border-y border-r border-[#345142]" />
    <div className="col-span-1 row-start-2 ml-[-1px] mt-[-1px] rounded-l-[4px] border-y border-l border-[#345142]" />
  </div>
)
